export function formatUSCurrency(value, includeCents = true) {
    const options = {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: includeCents ? 2 : 0,
    };
    return value?.toLocaleString("en-US", options);
}
